import Module, { moduleInit, ViewLayer, implementFunction } from "../../../../framework/core/mvvm/module_base";
import { SlotCarryView } from "./slot_carry_view";
import ModuleManager from "../../../../framework/core/module_manager";
import ModelData from "../../../public/model_data";
import UserDataManager, { IUserCurrencyData } from "../../../../manager/user_manager";
import LoaclStorage from "../../../../manager/local_storage";
import LanguageManager from "../../../../manager/language_manager";
import GameUtil from "../../../../utility/game_util";
import { TableHelp } from "../../../texasholdem/module/table/help/table_help";
import HallServer from "../../../hall/server/hall/hall_serve";
import EventManager from "../../../../manager/event_manager";

const { ccclass, property } = cc._decorator;

type callBack = (chipsNumb: number, autoBuy: Boolean) => void;



@ccclass
@moduleInit("SlotCarryModule")
export class SlotCarryModule extends Module<SlotCarryView, null> {

    sourceScence

    confirmCallback

    currency

    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.viewType = SlotCarryView;
        this.windowPrefabResPath = 'package/slot/slot_carry';
        this.needAnim = true
        this.needViewMask = true
        this.clickAnywhereClose = true
        this.needViewBaseCloseBtn = true;
        this.needViewBaseTitleBg = true
        this.needViewBaseBgMid = true
    }


    onShow(args) {
        this.currency = args.currency
        this.view.initBaseData(args.total, args.rule)
        this.view.currencyIcon(args.currency)
        this.sourceScence = args.scene
        this.confirmCallback = args.callFunc
    }

    protected onButtonClickName(name: string, customEventData) {
        switch (name) {
            case 'ConfirmBtn':
                this.confirmDeal()


                break;
            case "ReduceBtn":
                this.view.addReduceDeal(false)
                break;
            case "AddBtn":
                this.view.addReduceDeal(true)
                break
            case 'Closeui':
                ModuleManager.instance.destroyModule('SlotCarryModule')
                break;
            default:
                break;
        }
    }

    confirmDeal() {
        let value = Math.floor(this.view.curValue)
        let minValue = this.view.minValue
        if (value < minValue) {
            return
        }
        if (this.sourceScence == "goldentrance") {
            if (this.confirmCallback) {
                this.confirmCallback(value)
            }
        } else if (this.sourceScence == "game") {
            EventManager.instance.dispatch("confirm_carry_gold", value)
        }
        ModuleManager.instance.destroyModule('SlotCarryModule')
    }
}
